import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Container, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useState } from 'react';
import { getRules } from '../../services/info/info';

function Rules() {
    const [data, setData] = useState([]);

    const fetchData = async () => {
      try {
        const response = await getRules();
        setData(response.data);  // Assume the API returns an array of objects
      } catch (error) {
      }
    };
  useEffect(() => {
    // Fetch data from your API

    fetchData();
}, []);

  return (
    <Container sx={{marginY:"3rem"}}>
    {data.map((item, index) => (
      <Accordion key={index}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`panel${index}-content`}
          id={`panel${index}-header`}
        >
          <Typography sx={{fontSize:"16px" , fontWeight:"500"}}>{item.title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{fontSize:"14px" , fontWeight:"400" , textAlign:"justify" , marginBottom:3}} >{item.textghavanin}</Typography>
        </AccordionDetails>
      </Accordion>
    ))}
  </Container>
  )
}

export default Rules